<template>
  <a :href="jobUrl" class="jl-card jl-card--applied hc-applied-card">
    <JobCompanyLogo
      :company-name="appliedJob.job.company_name || appliedJob.job.job_designation"
      :logo-url="appliedJob.job.company_logo_url"
      root-class="jl-card__logo"
    />
    <div class="jl-card__body">
      <div class="jl-card__head">
        <div class="jl-card__title">{{ appliedJob.job.job_designation }}</div>
        <span class="jl-card__badge hc-applied-card__status" :class="statusClass">{{ statusLabel }}</span>
      </div>

      <p v-if="appliedJob.job.company_name" class="jl-card__company">
        <v-icon class="jl-card__meta-icon" size="14">{{ $icons.layers }}</v-icon>
        <span class="jl-card__company-text">{{ appliedJob.job.company_name }}</span>
      </p>

      <div class="hc-applied-card__steps" aria-label="Application progress">
        <div
          v-for="(step, index) in steps"
          :key="step.id"
          class="hc-applied-card__step"
          :class="{
            'is-done': index <= statusIndex,
            'is-current': index === statusIndex,
          }"
        >
          <span class="hc-applied-card__step-dot" aria-hidden="true"></span>
          <span class="hc-applied-card__step-label">{{ step.label }}</span>
        </div>
      </div>
    </div>

    <span class="jl-card__cta">View job</span>
  </a>
</template>

<script>
import JobCompanyLogo from '@/components/JobCompanyLogo.vue';

const STEPS = [
  { id: 0, label: 'Applied' },
  { id: 1, label: 'Screened' },
  { id: 2, label: 'Interviewed' },
  { id: 3, label: 'Offered' },
  { id: 4, label: 'Joined' },
];

const STATUS_LABELS = {
  0: 'Applied',
  1: 'Screened',
  2: 'Interviewed',
  3: 'Offered',
  4: 'Joined',
};

export default {
  name: 'AppliedJobCard',
  components: { JobCompanyLogo },
  props: {
    appliedJob: {
      type: Object,
      required: true,
    },
  },
  computed: {
    steps() {
      return STEPS;
    },
    statusIndex() {
      const status = Number(this.appliedJob.status);
      return Number.isFinite(status) ? Math.min(Math.max(status, 0), 4) : 0;
    },
    statusLabel() {
      return STATUS_LABELS[this.statusIndex] || 'Applied';
    },
    statusClass() {
      if (this.statusIndex >= 3) return 'hc-applied-card__status--success';
      if (this.statusIndex >= 1) return 'hc-applied-card__status--progress';
      return 'hc-applied-card__status--applied';
    },
    jobUrl() {
      return `/jobs/${this.appliedJob.param}`;
    },
  },
};
</script>
